<div
  (scrolled)="getNext()"
  [alwaysCallback]="true"
  [infiniteScrollDistance]="scrollDistance"
  [infiniteScrollThrottle]="throttle"
  [infiniteScrollUpDistance]="scrollUpDistance"
  [scrollWindow]="false"
  class="list-view-wrapper w-full md:mt-[0] mt-[2rem]"
  infinite-scroll
>
  <div class="list-view w-[90%] flex flex-col">

    <div class="search-section w-full flex justify-between">
      <div
        [ngClass]="{
            'w-full': !(role === allRoles.superAdmin && !isDrilldown)
        }"
        class="w-[70%] xs:w-full"
      >
        <app-text-input
          [parentFormGroup]="listFilterForm"
          [suffixIcon]="'search'"
          controlName="searchText"
          label="Search Resources"
          placeholder="Search Resources"
          type="small"
          (handleSuffixClick)="applyButtonClicked()"
        ></app-text-input>
      </div>
      <div *ngIf="role === allRoles.superAdmin && !isDrilldown"
           class="search-separator w-[2%] hidden sm:flex">
      </div>
      <div
        *ngIf="role === allRoles.superAdmin && !isDrilldown"
        class="add-resource-button-wrapper hidden sm:flex items-end justify-end w-[25%] sm:mt-[2rem] sm-[1.5rem]">
        <app-primary-button (handleClick)="navigateToAddResourceScreen()"
          class="w-[95%]"
          type="small">
          Add Resource
        </app-primary-button>
      </div>
    </div>
    <!-- Super Admin / Coach: Row 1 - Organisation, Group, Sessions, Status -->
    <div
      *ngIf="role === allRoles.superAdmin || role === allRoles.coach"
      class="view-list-filter-section flex flex-wrap items-end"
      [ngClass]="{
        'justify-between': role === allRoles.superAdmin,
        'justify-start sm:gap-[2%] md:gap-[1.33%]': role === allRoles.coach
      }">
      <div *ngIf="role === allRoles.superAdmin" class="w-full sm:w-[49%] md:w-[24%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="organisationsLoading"
          [options]="organisationOptions"
          [parentFormGroup]="listFilterForm"
          controlName="organisations"
          label="Organization"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div class="w-full sm:w-[49%] md:w-[24%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="groupsLoading"
          [options]="groupOptions"
          [parentFormGroup]="listFilterForm"
          controlName="groups"
          label="Group"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div class="w-full sm:w-[49%] md:w-[24%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="sessionLoading"
          [options]="sessionDropDownOptions"
          [parentFormGroup]="listFilterForm"
          controlName="sessions"
          label="Sessions"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div *ngIf="role === allRoles.superAdmin" class="w-full sm:w-[49%] md:w-[24%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="statusLoading"
          [options]="status"
          [parentFormGroup]="listFilterForm"
          controlName="status"
          label="Status"
          placeholder="Select all that apply"
          type="small"/>
      </div>
    </div>
    <!-- Super Admin / Coach: Row 2 - Categories, Sub Categories, Role, Apply -->
    <div
      *ngIf="role === allRoles.superAdmin || role === allRoles.coach"
      class="view-list-filter-section flex flex-wrap justify-between items-end">
      <div class="w-full sm:w-[49%] md:w-[24%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="categoriesLoading"
          [options]="categoriesDropDownList"
          [parentFormGroup]="listFilterForm"
          controlName="categories"
          label="Categories"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div class="w-full sm:w-[49%] md:w-[24%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="subCategoriesLoading"
          [options]="subCategoriesDropDownList"
          [parentFormGroup]="listFilterForm"
          controlName="subCategories"
          label="Sub Categories"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div class="w-full sm:w-[49%] md:w-[24%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="rolesLoading"
          [options]="rolesDropDownOptions"
          [parentFormGroup]="listFilterForm"
          controlName="roles"
          label="Role"
          placeholder="Select all that apply"
                      type="small"/>
      </div>
      <div class="btn w-full md:w-[24%] mb-[2rem]">
        <app-primary-button (handleClick)="applyButtonClicked()"
                            class="w-full"
                            type="small">
          Apply
        </app-primary-button>
      </div>
    </div>
    <!-- Non-Super Admin / Non-Coach: Single row - Sessions, Categories, Sub Categories, Role, Apply -->
    <div
      *ngIf="role !== allRoles.superAdmin && role !== allRoles.coach"
      class="view-list-filter-section flex flex-wrap justify-between items-end">
      <div
        [ngClass]="{
          'md:w-[18%]': role > allRoles.superAdmin,
          'md:w-[20%]': role === allRoles.participant
        }"
        class="w-full sm:w-[49%] md:w-[15%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="sessionLoading"
          [options]="sessionDropDownOptions"
          [parentFormGroup]="listFilterForm"
          controlName="sessions"
          label="Sessions"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div
        [ngClass]="{
          'md:w-[25%]': role > allRoles.superAdmin,
          'md:w-[30%]': role === allRoles.participant
        }"
        class="w-full sm:w-[49%] md:w-[20%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="categoriesLoading"
          [options]="categoriesDropDownList"
          [parentFormGroup]="listFilterForm"
          controlName="categories"
          label="Categories"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div
        [ngClass]="{
          'md:w-[25%]': role > allRoles.superAdmin,
          'md:w-[30%]': role === allRoles.participant
        }"
        class="w-full sm:w-[49%] md:w-[20%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="subCategoriesLoading"
          [options]="subCategoriesDropDownList"
          [parentFormGroup]="listFilterForm"
          controlName="subCategories"
          label="Sub Categories"
          placeholder="Select all that apply"
          type="small"/>
      </div>
      <div
        *ngIf="role === allRoles.clientAdmin || role === allRoles.coach ||
        role === allRoles.adult"
        [ngClass]="{
          'md:w-[18%]': role > allRoles.superAdmin
        }"
        class="w-full sm:w-[49%] md:w-[13%]">
        <app-dropdown [enableMultiple]="true"
          [loading]="rolesLoading"
          [options]="rolesDropDownOptions"
          [parentFormGroup]="listFilterForm"
          controlName="roles"
          label="Role"
          placeholder="Select all that apply"
                      type="small"/>
      </div>
      <div
        [ngClass]="{
          'md:w-[16%]': role === allRoles.participant
        }"
        class="btn w-full md:w-[10%] mb-[2rem]">
        <app-primary-button (handleClick)="applyButtonClicked()"
                            class="w-full"
                            type="small">
          Apply
        </app-primary-button>
      </div>
    </div>
  </div>
  <div class="list-view w-[90%]">
    <div
      *ngIf="!resourceDetails.loading || paginationRelatedLoading"
      class="resource-list-section grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4"
    >
      <div *ngFor="let resource of resourceDetails.list;let index=index"
           class="flex justify-center w-full">
        <app-resources-card [loggedInUserRole]="role"
                            [resource]="resource"
                            class="w-full"></app-resources-card>
      </div>
    </div>
    <div
      *ngIf="!resourceDetails?.loading && !resourceDetails.list.length"
      class="no-data flex flex-col justify-center items-center"
    >
      <div class="text">
        No data matching the filter.
      </div>
    </div>
    <div *ngIf="resourceDetails.loading && paginationRelatedLoading"
         class="flex justify-center items-center pagination-loading">
      <mat-spinner
        [diameter]="30"
        mode="indeterminate"
        strokeWidth="4"
      />
    </div>
    <div *ngIf="resourceDetails.loading && !paginationRelatedLoading"
         class="flex justify-center items-center loading-wrapper">
      <mat-spinner
        [diameter]="100"
        mode="indeterminate"
        strokeWidth="5"
      />
    </div>
  </div>
</div>
